export const name = 'x-input';
export * from './input.renderer';
